import { colorHash } from "lib/utils";
export default function UserTag({ userName }) {
  return (
    <div
      style={{
        height: "32px",
        width: "fit-content",
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#EEEEEE",
        borderRadius: "30px",
        padding: "0px 12px",
      }}
    >
      <div style={{ width: "32px", height: "100%", alignContent: "center" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "80px",
            backgroundColor: colorHash.hex(userName || ""),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            color: "white",
          }}
        >
          {userName?.substr(0, 1) || "U"}
        </div>
      </div>
      <div
        style={{
          width: "fit-content",
          height: "100%",
          alignContent: "center",
          lineHeight: "100%",
          color: "#222222",
          whiteSpace: "nowrap",
        }}
      >
        {userName || "Unknow Name"}
      </div>
    </div>
  );
}
